import './theming/capsulecat.scss';
